import React from "react";
import useScrollAnimation from "../constants/useScrollAnimation";
import "./Banner.css";

const Carousel = () => {
  const [bannerTextRef, isVisible] = useScrollAnimation(0.15);

  return (
    <section>
      <div>
        <div id="carouselExample" className="carousel slide">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src="/images/banner/pic.jpg" className="d-block w-100 zoom-mobile" alt="Slide 1" />
            </div>
            <div className="banner-title-sec">
              <div
                className="banner-title"
                style={{
                  backgroundImage: "url('/images/background.jpg')", // Change your image path
                }}
              >
                <div className="banner-title-overlay"></div>

                <div className="banner-title-content">
                  <div className={`banner-title-letter ${isVisible ? "animate-in" : ""}`}>T</div>

                  <div
                    ref={bannerTextRef}
                    className={`banner-title-text ${isVisible ? "animate-in" : ""}`}
                  >
                    <h2 className="banner-title-heading">
                      ransforming Potential Into
                      <br />
                      Excellence.
                    </h2>

                    <div className="banner-title-underline">
                      <svg
                        width="230"
                        height="34"
                        viewBox="0 0 230 34"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 12 Q95 -8 200 12"
                          stroke="#E32619"
                          strokeWidth="3"
                          fill="none"
                          strokeLinecap="round"
                        />
                        <path
                          d="M25 28 Q105 8 170 24"
                          stroke="#E32619"
                          strokeWidth="3"
                          fill="none"
                          strokeLinecap="round"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="book-icon">
              <img src="/images/banner/icon/book.png" alt="" />
            </div>
            <div className="idea-icon">
              <img src="/images/banner/icon/idea.png" alt="" />
            </div>
            <div className="book-icon">
              <img src="/images/banner/icon/book.png" alt="" />
            </div> */}
            {/* <div className="carousel-item">
            <img src={hero2} className="d-block w-100" alt="Slide 2" />
          </div> */}
            {/* <div className="carousel-item">
            <img src={hero3} className="d-block w-100" alt="Slide 3" />
          </div> */}
          </div>

          {/* <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExample"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExample"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button> */}
        </div>
      </div>
    </section>
  );
};

export default Carousel;
